import { Injectable } from '@angular/core';
import { WeissmanModalService } from '../Compliance/WeissmanModalService';
import { ContactModalOrigin } from '../constants.new';
import { ContactsUpgradeService } from './contacts.service.upgrade';
import { ContactModalComponent, ContactModalParams } from './View/contactModal.component';

// Needed to be its own service to prevent circular dependency
@Injectable({ providedIn: 'root' })
export class ContactModalService {
    constructor(
        private readonly _weissmanModalService: WeissmanModalService,
        private readonly _contactsService: ContactsUpgradeService
    ) {
    }

    async openContactDialog(contactId: number, origin: ContactModalOrigin, contacts?, entityInfo?, roles?): Promise<Weissman.Model.Contacts.Contact> {
        // problem: this dialog can be called from contact entity panel.
        // (contact list has real contacts) or from contacts view (we have list of contactDto objects)
        // ToDo: Re-factor contact detail dialog to better handle problem described above.
        const params: ContactModalParams = {
            contactId,
            entityInfo: entityInfo || null,
            roles: roles || null,
            origin
        };

        const contact = await this._weissmanModalService.showAsync(ContactModalComponent, params, 'modal-xl');

        if (contact) {
            const existingContact = this._contactsService.contacts.find(x => x.contactID === contact.contactID);

            if (!existingContact) {
                // this was a new contact, lets insert it
                this._contactsService.contacts = [...this._contactsService.contacts, contact];
            } else {
                // updating existing one
                if (existingContact['availableRoles']) {
                    contact['availableRoles'] = existingContact['availableRoles'];
                }
                this._copyContactProperties(contact, existingContact);
            }
        }

        return contact;
    }

    private _copyContactProperties(newContact: Weissman.Model.Contacts.Contact, existingContact: Weissman.Model.Contacts.Contact): void {
        existingContact.active = newContact.active;
        existingContact.contactID = newContact.contactID;
        existingContact.entityName = newContact.entityName;
        existingContact.firstName = newContact.firstName;
        existingContact.lastName = newContact.lastName;
        existingContact.title = newContact.title;
        existingContact.address = newContact.address;
    }
}
